import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { SurveyQuestionViewModel } from 'autogen/swagger/all';
import { Button } from 'components/Button';
import { chipDefaultStyling } from 'components/generic/Chip/Chip';
import { chipSizeStyling } from 'components/generic/Chip/shared/chipSizes';
import { chipVariantStyling } from 'components/generic/Chip/shared/chipVariants';
import type { ChipProps } from 'components/generic/Chip/shared/types';
import Flex from 'components/Layout/components/Flex';
import { isAboveNCharacters } from '../shared/helpers';
import { useSurveyResponseState } from './SurveyResponseStateProvider';

export const ButtonChip = styled.button<{ $size: ChipProps['size']; $variant: ChipProps['variant'] }>`
    ${chipDefaultStyling}
    ${chipSizeStyling}
    ${chipVariantStyling}
    border: none;
    white-space: nowrap;
`;

export default function SurveyQuickSingleAnswer({
    model: { answerOptions, id: questionId }
}: {
    model: SurveyQuestionViewModel;
}) {
    const { updateQuestionResponsesAndSubmitResponses } = useSurveyResponseState();

    const isFullWidth = answerOptions.some((answer) => isAboveNCharacters(answer.title, 15));

    return (
        <Flex direction={isFullWidth ? 'column' : 'row'} wrap="wrap" gap={Spacing8}>
            {answerOptions.map((answer) => {
                return (
                    <ButtonChip
                        $size="md"
                        $variant="primaryOutline"
                        key={answer.id}
                        onClick={async () => {
                            updateQuestionResponsesAndSubmitResponses({
                                questionId,
                                isSelectAllChosen: false,
                                id: 0,
                                answerOptionResponses: [
                                    {
                                        answerOptionId: answer.id,
                                        value: '',
                                        dynamicId: answer.dynamicData?.id || ''
                                    }
                                ]
                            });
                        }}
                    >
                        {answer.title}
                    </ButtonChip>
                );
            })}
        </Flex>
    );
}
